module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-bingdao-h5.b5bad52a.png";